import { Controller, useFormContext } from 'react-hook-form';
import { TextFieldWithLabel } from '@components/molecules';
import { ClinicCreateFormData } from '@/pages/admin/site-admin-clinic-info/clinicFormSchema';

const AuthorizedReceiptForm = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<ClinicCreateFormData>();

  return (
    <div>
      <h3 className="text-xl my-4 font-bold">レセプト印字委任欄代理人情報（個人請求用）</h3>
      <div className="grid grid-cols-3 gap-5">
        <Controller
          name="authorizedReceipt.representative_name"
          control={control}
          render={({ field }) => (
            <TextFieldWithLabel
              label="代理人氏名"
              {...field}
              value={field.value ?? ''}
              error={errors.authorizedReceipt?.representative_name}
            />
          )}
        />
        <Controller
          name="authorizedReceipt.representative_address"
          control={control}
          render={({ field }) => (
            <TextFieldWithLabel
              label="代理人住所"
              {...field}
              value={field.value ?? ''}
              error={errors.authorizedReceipt?.representative_address}
            />
          )}
        />
        <Controller
          name="authorizedReceipt.representative_telephone"
          control={control}
          render={({ field }) => (
            <TextFieldWithLabel
              label="代理人電話番号"
              {...field}
              value={field.value ?? ''}
              error={errors.authorizedReceipt?.representative_telephone}
            />
          )}
        />
      </div>
    </div>
  );
};

export default AuthorizedReceiptForm;
